/**
 * GaugeChart Threshold slot definition.
 * @public
 */
export interface GaugeChartThresholdProps {
  /**
   * The value of the threshold.
   */
  value: number;
  /**
   * When set to true, it shows the indicator of the threshold.
   * @defaultValue false
   */
  showIndicator?: boolean;
  /**
   * The color of the threshold.
   * @defaultValue 'Categorical.Color11'
   */
  color?: string;
}

export const Threshold = (_props: GaugeChartThresholdProps) => null;
